module.exports = __webpack_public_path__ + "img/rokustore.d4e3ff3b.png";